/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import MarkdownIt from "markdown-it";
import Vue from 'vue';

export const markdownIt = new MarkdownIt({
    breaks: true,
    typographer: true,
})

export const markdown = (text: string): string => markdownIt.render(text)

Vue.filter('markdown', markdown)
